<template>
  <exercise-logic
    exCollection="problemExCollection"
    @ready="onReady"
    @error="onError"
    @saved="onSaved"
    @savedNext="onSavedNext"
    @loadedEx="onLoadedEx"
    @loadedRefs="onLoadedRefs"
    :doc="doc"
    :shared="false"
  >
    <template slot-scope="{ saveExercise }">
      <v-stepper v-model="e1">
        <v-stepper-header>
          <v-stepper-step
            color="amber"
            :complete="e1 > 1"
            step="1"
            @click="el = 1"
            >Problem 1</v-stepper-step
          >
          <v-divider></v-divider>
          <v-stepper-step
            color="amber"
            :complete="e1 > 2"
            step="2"
            @click="el = 2"
            >Problem 2</v-stepper-step
          >
          <v-divider></v-divider>
        </v-stepper-header>

        <v-stepper-items>
          <!-- Step 1 -->
          <v-stepper-content step="1">
            <v-row>
              <v-col cols="4" class="mb-4">
                <h2
                  class="headline"
                >Problem 1</h2>
              </v-col>
              <v-col cols="8" lg="6" class="mb-4">
                <p
                  v-for="(item, index) in $t(
                    'exercise_problem.step1.description'
                  )"
                  :key="index"
                  v-text="item"
                />
              </v-col>
            </v-row>
            <v-row v-if="doc">
              <v-col cols="4">
                <unit-items-top
                  v-model="doc.factors1"
                  :limit="5"
                  name="col1"
                  :num="$t('exercise_problem.col1.num')"
                  :title="$t('exercise_problem.col1.title')"
                  :description="$t('exercise_problem.col1.description')"
                  color="amber"
                  bgColor="#494949"
                  svg="wing-left-new@2x.png"
                  :reverse="false"
                  :disabled="problemValid1"
                >
                </unit-items-top>
              </v-col>
              <v-col cols="4">
                <unit-items-center
                  v-model="doc.problem1"
                  :limit="1"
                  name="col2"
                  :num="$t('exercise_problem.col2.num')"
                  :title="$t('exercise_problem.col2.title')"
                  :description="$t('exercise_problem.col2.description')"
                  color="amber"
                  bgColor="#494949"
                  class="full-height"
                >
                </unit-items-center>
              </v-col>
              <v-col cols="4">
                <unit-items-top
                  v-model="doc.solution1"
                  :limit="5"
                  name="col3"
                  :num="$t('exercise_problem.col3.num')"
                  :title="$t('exercise_problem.col3.title')"
                  :description="$t('exercise_problem.col3.description')"
                  color="amber"
                  bgColor="#494949"
                  svg="wing-right-new@2x.png"
                  :reverse="true"
                  :disabled="problemValid1"
                >
                </unit-items-top>
              </v-col>
            </v-row>
            <bottom-navigation
              :save="false"
              :next="true"
              :prev="false"
              :gridView="false"
              :gridToggle="false"
              @save="saveExercise"
              @prev="prevStep"
              @next="saveExercise(false)"
            >
            </bottom-navigation>
          </v-stepper-content>
          <!-- Step 2 -->
          <v-stepper-content step="2">
            <v-row>
              <v-col cols="4" class="mb-4">
                <h2
                  class="headline"
                >Problem 2</h2>
              </v-col>
              <v-col cols="8" lg="6" class="mb-4">
                <p
                  v-for="(item, index) in $t(
                    'exercise_problem.step1.description'
                  )"
                  :key="index"
                  v-text="item"
                />
              </v-col>
            </v-row>
            <v-row v-if="doc">
              <v-col cols="4">
                <unit-items-top
                  v-model="doc.factors2"
                  :limit="5"
                  name="col1"
                  :num="$t('exercise_problem.col1.num')"
                  :title="$t('exercise_problem.col1.title')"
                  :description="$t('exercise_problem.col1.description')"
                  color="amber"
                   bgColor="#494949"
                  svg="wing-left-new@2x.png"
                  :reverse="false"
                  :disabled="problemValid2"
                >
                </unit-items-top>
              </v-col>
              <v-col cols="4">
                <unit-items-center
                  v-model="doc.problem2"
                  :limit="1"
                  name="col2"
                  :num="$t('exercise_problem.col2.num')"
                  :title="$t('exercise_problem.col2.title')"
                  :description="$t('exercise_problem.col2.description')"
                  color="amber"
                   bgColor="#494949"
                  class="full-height"
                >
                </unit-items-center>
              </v-col>
              <v-col cols="4">
                <unit-items-top
                  v-model="doc.solution2"
                  :limit="5"
                  name="col3"
                  :num="$t('exercise_problem.col3.num')"
                  :title="$t('exercise_problem.col3.title')"
                  :description="$t('exercise_problem.col3.description')"
                  color="amber"
                  bgColor="#494949"
                  svg="wing-right-new@2x.png"
                  :reverse="true"
                  :disabled="problemValid2"
                >
                </unit-items-top>
              </v-col>
            </v-row>
            <bottom-navigation
              :save="true"
              :next="false"
              :prev="true"
              :gridView="false"
              :gridToggle="false"
              @save="saveExercise"
              @prev="prevStep"
              @next="saveExercise(false)"
            >
            </bottom-navigation>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>

      <v-dialog v-model="dialog" max-width="500">
        <v-card>
          <v-card-title
            class="headline"
            v-text="$t('exercise_service.saved.title')"
          ></v-card-title>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="amber" text @click="closeDialog">
              Close
            </v-btn>

            <v-btn
              color="amber accent-1"
              text
              :to="`/users/project/${$route.params.id}`"
            >
              Back to Project
            </v-btn>
            <v-btn color="amber accent-1" text to="/users/dashboard">
              Back to Dashboard
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
  </exercise-logic>
</template>

<script>
// @ is an alias to /src
import { mapState } from "vuex";
import { BottomNavigation } from "@/components/core";
import { ExerciseLogic } from "@/components/exercises";
import { UnitItemsTop, UnitItemsCenter } from "@/components/units";

// const fb = require("@/firebaseConfig.js");

export default {
  name: "UserProblem",
  data() {
    return {
      e1: 1,
      doc: {
        problem1: [],
        factors1: [],
        solution1: [],
        problem2: [],
        factors2: [],
        solution2: [],
      },
      tabs: [{ title: "Empathy Maps", count: 1 }],
      userSelected: null,
      debug: false,
      dialog: false,
    };
  },
  components: {
    BottomNavigation,
    ExerciseLogic,
    UnitItemsTop,
    UnitItemsCenter,
  },
  computed: {
    ...mapState([
      "userProfile",
      "currentUser",
      "currentProject",
      "currentProjectModel",
    ]),
    problemValid1() {
      return (this.doc.problem1.length >= 1) ? false : true;
    },
    problemValid2() {
      return (this.doc.problem1.length >= 1) ? false : true;
    }
  },

  mounted() {},
  methods: {
    nextStep() {
      this.e1++;
      // this.saveExercise(false);
    },
    prevStep() {
      this.e1--;
      // this.saveExercise(false);
    },
    onReady() {},
    onError() {
      console.log("error");
    },
    onSaved() {
      console.log("saved");
      this.dialog = true;
    },
    onLoadedRefs(refs) {
      console.log("loaded", refs);
    },
    onLoadedEx(ex) {
      this.doc = ex.doc;
      this.exercise = ex;
    },
    onSavedNext() {
      this.nextStep();
    },
    closeDialog() {
      this.dialog = false;
    },
  },
};
</script>
